import React from 'react'
import ReactDOM from 'react-dom/client'
import { AppContextProvider } from './providers/context'
import { PageRouter } from './router'
import { AppName } from './constants'
import { ToastProvider } from './providers/toast'
import { TooltipProvider } from '@radix-ui/react-tooltip'
import { PopupProvider } from './providers/popups'
import ErrorBoundary from './providers/errorBoundary'
import { CallProvider } from './providers/callProvider'
import { TermsOfServiceProvider } from './pages/modals/termsOfService'
import { PusherProvider } from './providers/pusher'
import { NotificationsProvider } from './providers/pushNotificationProvider'
import { LanguagesContextProvider } from './providers/languages'
import { PriorityProvider } from './providers/modalPriorityProvider'
import { BrowserRouter } from 'react-router-dom'
import { URLParamsProvider } from './providers/URLParams'
import { DefaultPageTitle } from './routerComponents'

const rootElem = document.getElementById('root') as HTMLElement
const appName = (rootElem.getAttribute('appName') ?? 'ReachMyTeach') as AppName
const csrf = rootElem.getAttribute('csrf')!
const pusherKey = rootElem.getAttribute('pusherKey')!
const vapidPublicKey = rootElem.getAttribute('vapidPublicKey')!
// strict mode can mask issues with requests and things that only work after being done twice (ive seen this occasionally)
// another thing it breaks in home.tsx the effect that clears the conversationrequest runs twice,but the url param to open a
// conversation is only there the first time. so you never see the conversation.
const strict = !!rootElem.getAttribute('debug') && false
const root = ReactDOM.createRoot(rootElem)

const app = (
  <ErrorBoundary>
    <AppContextProvider appName={appName} csrf={csrf}>
      <LanguagesContextProvider>
        <PusherProvider pusherKey={pusherKey}>
          {/* The browser router needs to be outside the toast etc, so they can contain links. the <AppRouter/> is where routing actually occurs */}
          <BrowserRouter>
            <NotificationsProvider vapidPublicKey={vapidPublicKey}>
              <TooltipProvider delayDuration={0} skipDelayDuration={0}>
                <ToastProvider>
                  <PopupProvider>
                    <CallProvider>
                      <TermsOfServiceProvider>
                        <PriorityProvider>
                          <URLParamsProvider>
                            <DefaultPageTitle />
                            <PageRouter />
                          </URLParamsProvider>
                        </PriorityProvider>
                      </TermsOfServiceProvider>
                    </CallProvider>
                  </PopupProvider>
                </ToastProvider>
              </TooltipProvider>
            </NotificationsProvider>
          </BrowserRouter>
        </PusherProvider>
      </LanguagesContextProvider>
    </AppContextProvider>
  </ErrorBoundary>
)

root.render(strict ? <React.StrictMode>{app}</React.StrictMode> : app)
